export { assignContextOnAny, clearContext, EVENT_TYPE_DISMISS } from './context-events';
export { interpolateMustachifiedHTML } from './interpolate-mustache';
export { getUpflowyURLParams } from './get-params';
export type { UpflowyURLParams } from './get-params';
export { handleSubmitEvent, handleClickEventOfNonType } from './event-handlers';
export { formValuesToJSON, secureValues } from './form-to-json';
export { hideError, showError, removeErrors } from './view-helper';
export { startsWith, endsWith } from './utils';
export { resetSubmitButtons } from './reset-submits';

/*
  Prefix and Suffix with "_" when it's reserved by the system
  and shouldn't be allowed in users generated contents
*/

// Events are always uppercase
export const EVENT_TYPE_STATE_ENTER = 'STATE_ENTER';
export const EVENT_TYPE_SUBMIT = 'SUBMIT';
export const EVENT_TYPE_BACK = 'BACK';
export const EVENT_TYPE_SSO_INIT = 'SSO_INIT';
export const EVENT_TYPE_REDIRECT = 'REDIRECT';
export const EVENT_TYPE_SSO_SUCCESS = 'SSO_SUCCESS';
export const EVENT_TYPE_FLOW_READY = 'FLOW_READY';
export const EVENT_TYPE_FLOW_TRIGGER = 'FLOW_TRIGGER';
export const EVENT_TYPE_FLOW_INSERT = 'FLOW_INSERT';
export const EVENT_TYPE_FLOW_COMPLETE = 'FLOW_COMPLETE';
